import script from "./mobleFoot.vue?vue&type=script&setup=true&lang=js"
export * from "./mobleFoot.vue?vue&type=script&setup=true&lang=js"

import "./mobleFoot.vue?vue&type=style&index=0&id=8124ad02&lang=scss&scoped=true"

import exportComponent from "C:\\develop\\workspace_cursor\\weiquyun\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8124ad02"]])

export default __exports__